import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { auth0settings } from './helpers/settings';

const Auth0ProviderWithNavigate = ({ children }) => {
	const navigate = useNavigate();

	const onRedirectCallback = appState => {
		navigate(appState?.returnTo || window.location.pathname);
	};

	return (
		<Auth0Provider
			domain={auth0settings.domain}
			clientId={auth0settings.clientId}
			redirectUri={auth0settings.redirectUri}
			audience={auth0settings.audience}
			scope={auth0settings.scope}
			maxAge={auth0settings.maxAge}
			onRedirectCallback={onRedirectCallback}
			useRefreshTokens
		>
			{children}
		</Auth0Provider>
	);
};

export default Auth0ProviderWithNavigate;
